module.exports = __webpack_public_path__ + "static/img/function-2.b0a0252.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/function-2.png
// module id = ntt7
// module chunks = 0